import { MatrizTamanho, RequestBodyMaintainItem } from 'services/draft/interfaces'
import { TypesValidations } from 'constants/enums'
import { MaterialByIdResponse } from 'store/ProductContext'
import { SalesOrderData } from 'store/SalesOrderContext/types/SalesOrderData'
import { ProductContextState } from '..'
import { BOX_TYPE } from '../components/ProductDetail'
import { getUser } from 'commons/utils/user'

type smallMatriz = {
  codigo: string
  quantidade: string
}

interface BodyProductProps {
  state: ProductContextState
  materialSelected: MaterialByIdResponse
  filter: string[]
  defaultSizes: Record<string, string | string[] | boolean | Record<string, number>>
  draftBody?: SalesOrderData
  materialDiscount?: number
}

export default function BodyPostProduct({
  state,
  materialSelected,
  filter,
  draftBody,
  defaultSizes,
  materialDiscount
}: BodyProductProps) {
  const hasFilter = filter.length > 0
  function createMatrizFields(key: string) {
    return Object.entries(state[key]).map((size) => {
      const colorSelected = materialSelected.cores.find((cor) => cor.ds_cor === key)
      const partialDefault = defaultSizes[key] as Record<string, number>
      const defaultKey = partialDefault[size[0]]

      if (size[1]) {
        return {
          cd_tamh: size[0],
          qt_item: Number(size[1]),
          cd_cor: colorSelected?.cd_cor,
          fl_excl_item: TypesValidations.NO,
          fl_sele: TypesValidations.YES
        }
      }
      if (defaultKey) {
        return {
          cd_tamh: size[0],
          qt_item: 0,
          cd_cor: colorSelected?.cd_cor,
          fl_excl_item: TypesValidations.YES,
          fl_sele: TypesValidations.YES
        }
      }
    })
  }

  const filteredMatriz: MatrizTamanho[] = []

  for (const key in state) {
    if (
      ![
        'cd_cent_matr',
        'percentualDesconto',
        'fl_caix_grad',
        'qt_caix_grad',
        'disabledColorsRow',
        'dirtyFieldsByColor',
        'disabled_fl_caix_grad'
      ].includes(key)
    ) {
      if (hasFilter) {
        if (filter.includes(key.toLowerCase())) {
          filteredMatriz.push(...(createMatrizFields(key) as unknown as MatrizTamanho[]))
        }
      } else {
        filteredMatriz.push(...(createMatrizFields(key) as unknown as MatrizTamanho[]))
      }
    }
  }

  const matriz = filteredMatriz.filter((item) => typeof item !== 'undefined')
  const bodyItem: RequestBodyMaintainItem = {
    nr_pedi_rasc: draftBody?.nr_pedi_rasc as string,
    nr_item_pedi_rasc: materialSelected?.nr_item_pedi_rasc,
    cd_matr: materialSelected?.cd_matr,
    cd_cent_matr: (state['cd_cent_matr'] as string) || materialSelected?.cd_cent_matr,
    fl_conv:
      materialSelected.ds_tipo_caix === BOX_TYPE.CLOSED
        ? TypesValidations.NO
        : TypesValidations.YES,
    fl_caix_grad: state?.fl_caix_grad ? TypesValidations.YES : TypesValidations.NO,
    qt_caix_grad: state?.qt_caix_grad ? Number(state?.qt_caix_grad) : 0,
    pc_dsct: materialDiscount || draftBody?.pc_dsct || 0,
    matriz,
    cd_usua_alte: getUser()
  }

  return bodyItem
}

export const createMatriz = ({
  materialSelected,
  state,
  filter,
  defaultSizes
}: BodyProductProps) => {
  const hasFilter = filter.length > 0
  const matrizFields = (key: string) => {
    return Object.entries(state[key]).map((size) => {
      const colorSelected = materialSelected.cores.find((cor) => cor.ds_cor === key)
      const partialDefault = defaultSizes[key] as Record<string, number>
      const defaultKey = partialDefault[size[0]]
      if (size[1]) {
        return {
          codigo: colorSelected?.cd_cor + size[0],
          quantidade: size[1]?.toString()
        }
      }

      if (defaultKey) {
        return {
          codigo: colorSelected?.cd_cor + size[0],
          quantidade: '0'
        }
      }
    })
  }

  const filteredMatriz: smallMatriz[] = []

  for (const key in state) {
    if (
      ![
        'cd_cent_matr',
        'percentualDesconto',
        'fl_caix_grad',
        'qt_caix_grad',
        'disabledColorsRow',
        'dirtyFieldsByColor',
        'disabled_fl_caix_grad'
      ].includes(key)
    ) {
      if (hasFilter) {
        if (filter.includes(key.toLowerCase())) {
          filteredMatriz.push(...(matrizFields(key) as unknown as smallMatriz[]))
        }
      } else {
        filteredMatriz.push(...(matrizFields(key) as unknown as smallMatriz[]))
      }
    }
  }

  return filteredMatriz.filter((item) => typeof item !== 'undefined')
}
